import React from 'react';
import {useSelector} from 'react-redux';
import LinkPilesComponent from './LinkPiles';

const LinkPiles = () => {
    const linkPiles = useSelector((state) => state.modules?.linkPiles);

    return <LinkPilesComponent linkPiles={linkPiles} />;
};

LinkPiles.displayName = 'LinkPiles';

export default LinkPiles;
